import React from "react";
import { useTranslation } from "@/context/LanguageContext";

export const PricingTrustedBy = () => {
  const { t } = useTranslation();

  const universities = [
    { name: "Imam Abdulrahman Bin Faisal University", logo: "/images/logos/imam-abdulrahman.png", width: "w-24" },
    { name: "King Abdulaziz University", logo: "/images/logos/king-abdulaziz.png", width: "w-20" },
    { name: "KAUST", logo: "/images/logos/kaust.png", width: "w-20" },
    { name: "Prince Mohammad Bin Fahd University", logo: "/images/logos/pmu.png", width: "w-20" },
    { name: "Princess Nourah University", logo: "/images/logos/princess-nourah.png", width: "w-24" },
    { name: "Umm Al-Qura University", logo: "/images/logos/umm-al-qura.png", width: "w-20" },
  ];

  return (
    <div className="flex flex-col items-center gap-8 py-12">
      <h2 className="text-muted-foreground text-sm font-medium uppercase tracking-wider">
        {t("pricing.trustedBy")}
      </h2>

      <div className="flex flex-nowrap justify-center items-center gap-6 lg:gap-10 overflow-x-auto max-w-full px-4">
        {universities.map((uni) => (
          <img
            key={uni.name}
            src={uni.logo}
            alt={`${uni.name} logo`}
            className={`${uni.width} h-auto object-contain opacity-70 hover:opacity-100 transition-opacity duration-300 dark:brightness-90`}
            loading="lazy"
          />
        ))}
      </div>
    </div>
  );
};
